import React from 'react'
import SmartMenuItem from './SmartMenuItem'

const SmartMenuList = ({ items, ...props }) => (
  <ul {...props}>
    {items.map(item => <SmartMenuItem item={item} key={item._id} />)}
  </ul>
)

export default SmartMenuList
